import { render, staticRenderFns } from "./TicaOrderchampLogo.vue?vue&type=template&id=4312bef0&scoped=true"
import script from "./TicaOrderchampLogo.vue?vue&type=script&lang=js"
export * from "./TicaOrderchampLogo.vue?vue&type=script&lang=js"
import style0 from "./TicaOrderchampLogo.vue?vue&type=style&index=0&id=4312bef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4312bef0",
  null
  
)

export default component.exports